import baseAPI from '@/api/base';
import { EditOvertimeSetting, GetOvertimeSetting, RegisterOvertimeSetting } from '@/dtos/overtime_setting.dto';
import {
  CHECK_OVERTIME_SETTING_URL,
  DELETE_OVERTIME_SETTING_URL,
  EDIT_OVERTIME_SETTING_URL,
  GET_OVERTIME_SETTING_URL,
  REGISTER_OVERTIME_SETTING_URL,
  TOGGLE_OVERTIME_SETTING_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class OvertimeSetting {
  static getOvertimeSettings = async (getOvertimeSetting: GetOvertimeSetting): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_OVERTIME_SETTING_URL, {
      params: getOvertimeSetting,
    });
    console.log('response', response);
    return response;
  };

  static chekOvertimeSettingIsUsed = async (getOvertimeSetting: GetOvertimeSetting): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(CHECK_OVERTIME_SETTING_URL, {
      params: getOvertimeSetting,
    });
    console.log('response', response);
    return response;
  };

  static registerOvertimeSetting = async (
    registerOvertimeSetting: RegisterOvertimeSetting
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_OVERTIME_SETTING_URL, {
      ...registerOvertimeSetting,
    });
    console.log('response', response);
    return response;
  };

  static editOvertimeSetting = async (editOvertimeSetting: EditOvertimeSetting): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_OVERTIME_SETTING_URL, {
      ...editOvertimeSetting,
    });
    return response;
  };

  static toggleOvertimeSettingIsActive = async (
    editOvertimeSetting: EditOvertimeSetting
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_OVERTIME_SETTING_IS_ACTIVE_URL,
      {
        ...editOvertimeSetting,
      }
    );
    return response;
  };

  static deleteOvertimeSetting = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_OVERTIME_SETTING_URL}/${userId}`
    );
    return response;
  };
}

export default OvertimeSetting;
